module.exports = __webpack_public_path__ + "static/img/newAreaBg.6078530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/newAreaBg.jpg
// module id = a8/E
// module chunks = 0